/* LUNARA — reveal-on-scroll observer (tiny, no dependencies) */
(() => {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.lunara-reveal').forEach(el => el.classList.add('is-in'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  const attach = () => document.querySelectorAll('.lunara-reveal:not(.is-in)').forEach(el => io.observe(el));
  attach();
  document.addEventListener('shopify:section:load', attach);
  document.addEventListener('shopify:section:reorder', attach);
})();
